<template>
  <div class="e-module e-module--limited e-module--shadow">
    <div class="e-form e-form--register">
      <!-- Title -->
      <div class="e-form__title">
        <h1>{{ $t('system.forgotUsername.title') }}</h1>
      </div>

      <div class="e-form__content" v-html="$t('system.forgotUsername.body')" />

      <el-form
        ref="forgotUserForm"
        :model="forgotUserForm"
        :rules="rules"
        method="post"
      >
        <!-- Errormessages -->
        <el-alert
          v-for="(item, index) in errors.messages"
          :key="index"
          :title="$t(index)"
          type="error"
          v-html="$t(item)"
        />
        <!-- /Errormessages -->

        <el-alert
          v-if="errorWithLink"
          :title="$t('system.attention')"
          type="error"
        >
          {{ errorWithLink.prepend }}
          <router-link :to="{ name: errorWithLink.routeName }">
            {{ errorWithLink.linkText }}
          </router-link>
          {{ errorWithLink.append }}
        </el-alert>
        <!-- /Errormessages -->

        <!-- Successmessage -->
        <el-alert
          v-if="formSuccess"
          :title="$t('messages.user.forgotUsername.success')"
          type="success"
        />
        <!-- /Errormessages -->

        <!-- Row -->
        <el-form-item :label="$t('system.register.email')" prop="email">
          <el-input
            v-model="forgotUserForm.email"
            :placeholder="$t('system.register.emailPlaceholder')"
            type="email"
            name="email"
          />
        </el-form-item>

        <!-- Row -->
        <el-form-item :label="$t('system.login.password')" prop="password">
          <el-input
            v-model="forgotUserForm.password"
            :placeholder="$t('system.login.password')"
            type="password"
            name="password"
          />
        </el-form-item>

        <!-- Row -->
        <div class="e-form__row e-form__row--submit">
          <router-link
            :to="{ name: 'index' }"
            class="e-btn e-btn--ghost e-btn--large"
          >
            {{ $t('system.back') }}
          </router-link>

          <el-button
            :loading="loading"
            type="secondary"
            size="large"
            native-type="submit"
            @click.prevent="submitForm('forgotUserForm')"
          >
            {{ $t('system.forgotUsername.submit') }}
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from 'api'
import { userActions } from 'mixins'

export default {
  name: 'FormUserForgot',
  mixins: [userActions],
  data() {
    const validateEmail = (rule, value, callback) => {
      if (!this.validateMail(value)) {
        callback(new Error(this.$t('messages.user.email.invalid')))
      } else {
        callback()
      }
    }

    return {
      loading: false,
      forgotUserForm: {
        email: '',
        password: ''
      },
      rules: {
        password: [
          {
            required: true,
            message: this.$t('messages.user.password.empty')
          }
        ],
        email: [{ required: true, validator: validateEmail, trigger: 'blur' }]
      },
      errorWithLink: false,
      errors: false,
      formSuccess: false
    }
  },
  methods: {
    submitForm(formName) {
      if (this.$refs[formName]) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.sendForm()
          } else {
            return false
          }
        })
      }
    },

    sendForm: async function() {
      this.loading = true
      this.formSuccess = false
      this.errors = []
      this.errorWithLink = false

      try {
        const response = await api.call('forgotUsername', false, {
          email: this.forgotUserForm.email,
          password: this.forgotUserForm.password
        })

        if (response.status === 200) {
          this.formSuccess = true
          this.forgotUserForm.email = ''
          this.forgotUserForm.password = ''
        }
      } catch (error) {
        if (
          error.messages &&
          error.messages[0] !== 'messages.user.account.unconfirmed'
        ) {
          this.errors = error
        } else {
          this.errorWithLink = {
            prepend: this.$t('messages.user.account.unconfirmed.prepend'),
            linkText: this.$t('messages.user.account.unconfirmed.linkText'),
            routeName: 'resendConfirmMail',
            append: this.$t('messages.user.account.unconfirmed.append')
          }
        }
      } finally {
        this.loading = false
      }
    },

    validateMail(email) {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(email)
    }
  }
}
</script>

<style lang="scss">
// @import '_assets/loginform';
</style>
